<template>
  <div class="indexs">
    <div class="bdboxa">
      <div class="swipers">
        <swiper :options="cards[0].options" v-if="cards[0].data.length">
          <swiper-slide v-for="(item, index) in cards[0].data" :key="index" v-if="item.more.thumbnail">
            <img class="imgs" :src="item.more.thumbnail" alt="" @click="todetail(cards[0].category_id, item.id)" />
            <span class="titles" @click="todetail(cards[0].category_id, item.id)">{{ item.post_title }}</span>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
      </div>
      <div class="rightbox">
        <div class="top">
          <div class="titles">
            <span class="names">【&nbsp;&nbsp;{{ cards[1].name }}&nbsp;&nbsp;】</span>
            <span class="lookmore" @click="tolist(cards[1].category_id)">更多>></span>
          </div>
          <div class="boxlist">
            <span class="boxli" v-for="(item, index) in cards[1].data" :key="index" @click="todetail(cards[1].category_id, item.id)"
              ><span class="slot">·</span>
              <span class="liinfos">{{ item.post_title }}</span>
              <div class="time">{{ getYearMonth(item.published_time) }}</div>
            </span>
          </div>
        </div>
        <!-- <div class="top">
          <div class="titles">
            <span class="names">【&nbsp;&nbsp;{{ cards[2].name }}&nbsp;&nbsp;】</span>
            <span class="lookmore" @click="tolist(cards[2].category_id)">更多>></span>
          </div>
          <div class="boxlist">
            <span class="boxli" v-for="(item, index) in cards[2].data" :key="index" @click="todetail(cards[2].category_id, item.id)">
              <span class="slot">·</span>
              <span class="liinfos">{{ item.post_title }}</span>
              <div class="time">{{ getYearMonth(item.published_time) }}</div>
            </span>
          </div>
        </div> -->
      </div>
    </div>
    <div class="bdboxb bdboxa">
      <div class="top">
        <div class="titles">
          <span class="names">【&nbsp;&nbsp;{{ cards[3].name }}&nbsp;&nbsp;】</span>
          <span class="lookmore" @click="tolist(cards[3].category_id)">更多>></span>
        </div>
        <div class="boxlist">
          <span class="boxli" v-for="(item, index) in cards[3].data" :key="index" @click="todetail(cards[3].category_id, item.id)">
            <span class="slot">·</span>
            <span class="liinfos">{{ item.post_title }}</span>
            <div class="time">{{ getYearMonth(item.published_time) }}</div>
          </span>
        </div>
      </div>
      <div class="top">
        <div class="titles">
          <span class="names">【&nbsp;&nbsp;{{ cards[4].name }}&nbsp;&nbsp;】</span>
          <span class="lookmore" @click="tolist(cards[4].category_id)">更多>></span>
        </div>
        <div class="boxlist">
          <span class="boxli" v-for="(item, index) in cards[4].data" :key="index" @click="todetail(cards[4].category_id, item.id)">
            <span class="slot">·</span>
            <span class="liinfos">{{ item.post_title }}</span>
            <div class="time">{{ getYearMonth(item.published_time) }}</div>
          </span>
        </div>
      </div>
    </div>
    <div class="title">
      <span class="ttinfo"><span></span>【&nbsp;&nbsp;{{ cards[5].name }}&nbsp;&nbsp;】<span></span></span>
      <span class="lookmore" @click="tolist(cards[5].category_id)">更多>></span>
    </div>
    <div class="bdboxc bdboxa">
      <div class="audio">
        <div class="audioli" v-for="(item, index) in cards[5].data" :key="index" @click="todetail(cards[5].category_id, item.id)">
          <div class="info">
            <img class="imgs" :src="item.more.thumbnail" />
            <span class="audioname">{{ item.post_title }}</span>
          </div>
        </div>
      </div>
      <!-- <div v-if="showOverlay" class="overlay">{{ cards[5].data[showOverlayindex].post_title }}</div> -->
    </div>
    <!-- <div class="title titlea">
      <span class="ttinfo"><span></span>【&nbsp;&nbsp;会议聚焦&nbsp;&nbsp;】<span></span></span>
    </div> -->

    <div class="bdboxd bdboxa bdboxb">
      <div class="bdinfo">
        <div class="top">
          <div class="titles">
            <span class="names">【&nbsp;&nbsp;{{ cards[6].name }}&nbsp;&nbsp;】</span>
            <span class="lookmore" @click="tolist(cards[6].category_id)">更多>></span>
          </div>
          <div class="boxlist">
            <span class="boxli" v-for="(item, index) in cards[6].data" :key="index" @click="todetail(cards[6].category_id, item.id)">
              <span class="slot">·</span>
              <span class="liinfos">{{ item.post_title }}</span>
              <div class="time">{{ getYearMonth(item.published_time) }}</div>
            </span>
          </div>
        </div>
        <div class="top">
          <div class="titles">
            <span class="names">【&nbsp;&nbsp;{{ cards[7].name }}&nbsp;&nbsp;】</span>
            <span class="lookmore" @click="tolist(cards[7].category_id)">更多>></span>
          </div>
          <div class="boxlist">
            <span class="boxli" v-for="(item, index) in cards[7].data" :key="index" @click="todetail(cards[7].category_id, item.id)">
              <span class="slot">·</span>
              <span class="liinfos">{{ item.post_title }}</span>
              <div class="time">{{ getYearMonth(item.published_time) }}</div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="title titlea">
      <span class="ttinfo"><span></span>【&nbsp;&nbsp;会场内外&nbsp;&nbsp;】<span></span></span>
    </div> -->
    <div class="bdboxd bdboxa bdboxb">
      <div class="bdinfo">
        <div class="top">
          <div class="titles titlesd">
            <span class="names">【&nbsp;&nbsp;{{ cards[8].name }}&nbsp;&nbsp;】</span>
            <span class="lookmore" @click="tolist(cards[8].category_id)">更多>></span>
          </div>
          <div class="boxlist">
            <span class="boxli" v-for="(item, index) in cards[8].data" :key="index" @click="todetail(cards[8].category_id, item.id)">
              <span class="slot">·</span>
              <span class="liinfos">{{ item.post_title }}</span>
              <div class="time">{{ getYearMonth(item.published_time) }}</div>
            </span>
          </div>
        </div>
        <div class="top topd">
          <div class="titles">
            <!-- <span class="names">【&nbsp;&nbsp;{{ cards[9].name }}&nbsp;&nbsp;】</span>
            <span class="lookmore" @click="tolist(cards[9].category_id)">更多>></span> -->
          </div>
          <div class="boxlist">
            <span v-if="index > 4" class="boxli" v-for="(item, index) in cards[9].data" :key="index" @click="todetail(cards[9].category_id, item.id)">
              <span class="slot">·</span>
              <span class="liinfos">{{ item.post_title }}</span>
              <div class="time">{{ getYearMonth(item.published_time) }}</div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="title" id="lingdao">
      <span class="ttinfo"><span></span>【&nbsp;&nbsp;新一届会领导&nbsp;&nbsp;】<span></span></span>
    </div>
    <div class="bdboxe">
      <div class="infobd">
        <div class="bdli">
          <div class="ttname">{{ cards[10].name }}</div>
          <div class="users" :class="'users_' + 0">
            <div class="uinfo" v-for="(user, u) in cards[10].data" :key="u" @click="todetail(cards[10].category_id, user.id)">
              <img :src="user.more.thumbnail" alt="" />
              <span class="names">{{ user.post_title }}</span>
            </div>
          </div>
        </div> -->

    <!-- <div class="bdli">
          <div class="ttname">{{ cards[11].name }}</div>
          <div class="users" :class="'users_' + 1">
            <div class="uinfo" v-for="(user, u) in cards[11].data" :key="u" @click="todetail(cards[11].category_id, user.id)">
              <img :src="user.more.thumbnail" alt="" />
              <span class="names">{{ user.post_title }}</span>
            </div>
          </div>
        </div> -->

    <!-- <div class="bdli">
          <div class="ttname">{{ cards[12].name }}</div>
          <div class="users" :class="'users_' + 2">
            <div class="uinfo" v-for="(user, u) in cards[12].data" :key="u" @click="todetail(cards[12].category_id, user.id)">
              <img :src="user.more.thumbnail" alt="" />
              <span class="names">{{ user.post_title }}</span>
            </div>
          </div>
        </div> -->

    <!-- <div class="bdli">
          <div class="ttname">{{ cards[13].name }}</div>
          <div class="users" :class="'users_' + 3">
            <div class="uinfo" v-for="(user, u) in cards[13].data" :key="u" @click="todetail(cards[13].category_id, user.id)">
              <img :src="user.more.thumbnail" alt="" />
              <span class="names">{{ user.post_title }}</span>
            </div>
          </div>
        </div> -->

    <!-- <div class="bdli">
          <div class="ttname">{{ cards[14].name }}</div>
          <div class="users users_fhz" :class="'users_' + 4">
            <div class="uinfo" v-for="(user, u) in cards[14].data" :key="u" @click="todetail(cards[14].category_id, user.id)">
              <span class="names">{{ user.post_title }}</span>
            </div>
          </div>
        </div> -->

    <!-- <div class="bdlien">
          <span class="liinfo" v-for="(item, index) in cards[15].data" :key="index" @click="todetail(cards[15].category_id, item.id)">【&nbsp;&nbsp;{{ item.post_title }}&nbsp;&nbsp;】</span>
        </div> -->
  </div>
  <!-- </div> -->
  <!-- </div> -->
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  name: "index",
  props: {},
  data() {
    return {
      cards: [
        {
          type: "swiper",
          name: "swiper",
          options: {
            loop: true,
            autoplay: {
              disableOnInteraction: false,
              delay: 3000
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            }
          },
          category_id: "160",
          limit: 5,
          data: []
        },
        {
          type: "list",
          name: "要闻推荐",
          category_id: "79",
          limit: 13,
          data: []
        },
        {
          type: "list",
          name: "大会公告",
          category_id: "80",
          limit: 5,
          data: []
        },
        {
          type: "list",
          name: "回顾展望",
          category_id: "81",
          limit: 5,
          data: []
        },
        {
          type: "list",
          name: "新闻报道",
          category_id: "82",
          limit: 5,
          data: []
        },
        {
          type: "list",
          name: "会议视频",
          category_id: "83",
          limit: 2,
          data: []
        },
        {
          type: "list",
          name: "会议聚焦",
          category_id: "84",
          limit: 5,
          data: []
        },
        {
          type: "list",
          name: "双先风采",
          category_id: "113",
          limit: 5,
          data: []
        },
        // {
        //   type: "list",
        //   name: "会议文件",
        //   category_id: "124",
        //   limit: 5,
        //   data: []
        // },
        {
          type: "list",
          name: "学习贯彻",
          category_id: "125",
          limit: 5,
          data: []
        },
        {
          type: "list",
          name: "学习贯彻",
          category_id: "125",
          limit: 10,
          data: []
        },
        {
          type: "list",
          name: "会 长",
          category_id: "126",
          limit: 5,
          data: []
        },
        {
          type: "list",
          name: "党组书记、常务副会长",
          category_id: "127",
          limit: 5,
          data: []
        },
        {
          type: "list",
          name: "副会长兼秘书长",
          category_id: "128",
          limit: 5,
          data: []
        },
        {
          type: "list",
          name: "副会长",
          category_id: "129",
          limit: 5,
          data: []
        },
        {
          type: "list",
          name: "副会长",
          category_id: "130",
          limit: 32,
          data: []
        },
        {
          type: "list",
          name: "其他",
          category_id: "157",
          limit: 3,
          data: []
        }
      ],
      jump: ""
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getCategory();
    this.$nextTick(function () {
      if (this.$route.query.jump) {
        this.goAnchor(this.$route.query.jump);
      }
    });
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal.jump) {
          this.goAnchor(newVal.jump);
        }
      }
    }
  },
  methods: {
    goAnchor(id) {
      document.querySelector("#" + id).scrollIntoView({ behavior: "smooth" });
    },
    okshowOverlay(i) {
      this.showOverlay = true;
      this.showOverlayindex = i;
    },
    noshowOverlay(i) {
      this.showOverlay = false;
      this.showOverlayindex = i;
    },
    tolist(id) {
      this.$router.push({ name: "list", query: { categoryid: id } });
    },
    getArticles() {
      for (let i = 0; i < this.cards.length; i++) {
        this.getarticleslist(i);
      }
    },
    getCategory() {
      this.$api.get({
        url: "categories",
        success: (res) => {
          if (res.data.list.length > 0) {
            this.getArticles();
          }
        }
      });
    },
    getarticleslist(i) {
      let category_id = this.cards[i].category_id;
      this.$api.get({
        url: "articles",
        data: {
          page: this.cards[i].page ? this.cards[i].page : 1,
          category_id: category_id,
          limit: this.cards[i].limit
        },
        success: (res) => {
          this.cards[i].data = res.data.list.data;
        }
      });
    },
    todetail(id, cid) {
      // this.$router.push({
      //   name: "detail",
      //   query: { categoryid: id, postid: cid }
      // });
      const routeData = this.$router.resolve({
        name: "detail",
        query: { categoryid: id, postid: cid }
      });
      window.open(routeData.href, "_blank");
    },
    getYearMonth(e) {
      let year = e.toString().substr(2, 2);
      let month = e.toString().substr(5, 2);
      let day = e.toString().substr(8, 2);
      return month + "-" + day;
    }
  },
  components: {
    swiper,
    swiperSlide
  }
};
</script>

<style scoped lang="scss">
.swiper-button-prev,
.swiper-button-next {
  color: #fff !important;
  font-size: 5px !important;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 25px;
}
.liinfos:hover {
  color: #b80808;
  font-weight: bold !important;
}

.names:hover {
  color: #b80808;
  font-weight: bold !important;
}
@media all and (max-width: 800px) {
  .indexs {
    width: 100% !important;
    padding-bottom: 50px;
    margin-top: -38px !important;
    .boxli {
      position: relative;
      .liinfos {
        width: 78% !important;
      }
      .time {
        position: absolute;
        right: 10px !important;
      }
    }
    .bdboxa {
      width: 95% !important;
      flex-direction: column !important;
      align-items: center;
      justify-content: none !important;
      padding: 0 !important;
      font-size: 14px !important;
      margin-bottom: 10px !important;
      background: #fff !important;
      border-bottom: 3px solid #c80d10;
      //   margin-top: 40px !important;

      .swipers {
        width: 100% !important;
        height: 300px !important;
        background: #fff !important;
        // padding: 10px !important;
        .imgs {
          height: 300px !important;
          // height: 100% !important;
        }
      }
      .rightbox {
        margin-top: 20px;
        width: 95% !important;
        .top {
          .boxlist {
            height: 380px !important; //如果打开大会公告这里恢复170
          }
        }
      }
    }
    .bdboxb {
      background: #fff !important;
      .top {
        margin-top: 10px;
        width: 95% !important;
        .boxlist {
          height: 170px !important;
        }
      }
    }
    .bdboxc {
      width: 95% !important;
      background: #fff !important;
      // align-items: start !important;
      .titles {
        margin-top: 10px !important;
      }
      .audio {
        width: 95% !important;
        justify-content: center !important;
        overflow-x: scroll !important;
        gap: 10px !important;
        .audioli {
          cursor: pointer;
          width: 180px !important;
          .info {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #c7080d;
            .imgs {
              display: flex;
              align-items: center;
              width: 180px !important;
              height: 135px !important;
              margin-bottom: 10px;
            }
            .audioname {
              width: 180px !important;
            }
          }
        }
      }
    }
    .title {
      .ttinfo {
        display: flex !important;
        // justify-content: center !important;
        font-size: 20px !important;
        margin-left: 15px !important;
        span {
          width: 12px !important;
          height: 20px !important;
        }
      }
    }
    .titlea {
      // justify-content: center !important;
      margin-bottom: 10px !important;
    }
    .bdboxd {
      width: 95% !important;
      background: #fff !important;
      .bdinfo {
        margin-top: 0 !important;
        flex-direction: column !important;
        justify-content: none !important;
        height: 450px !important;
        .top {
          .titlesd {
            width: 100% !important;
          }
          .boxlist {
            margin-top: none !important;
          }
        }
        .topd {
          .titles {
            display: none !important;
          }
          .boxlist {
            margin-top: -245px !important;
          }
        }
      }
    }
    .bdboxe {
      width: 100%;
      justify-content: center;
      .infobd {
        .bdli {
          height: 160px !important;
          .ttname {
            width: 25px !important;
            height: 140px !important;
            font-size: 12px !important;
          }
          .users {
            .uinfo {
              img {
                width: 60px !important;
                height: 80px !important;
              }
              .names {
                font-size: 12px !important;
              }
            }
          }
        }
        .bdlien {
          .liinfo {
            width: 120px !important;
            height: 30px !important;
            font-size: 14px !important;
            border: 1px solid #ae0003 !important;
          }
        }
      }
    }
  }
  .users_fhz {
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr !important;
  }
  .indexs .title {
    width: 95% !important;
  }
  .indexs .bdboxc {
    height: 240px !important;
  }
  .indexs .bdboxc .audio {
    margin-top: 0px !important;
  }
  .indexs .bdboxe .infobd {
    .bdli {
      width: 95% !important;
      margin: 0 auto;
    }
  }
}

.lookmore {
  cursor: pointer;
  font-size: 13px;
}

.indexs {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1170px;
  margin: 0 auto;
  margin-top: -44px;
  color: #000;
  padding-top: 10px;
  margin-bottom: 20px;
  .bdboxa {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background: url("https://fxhoss.chinalaw.org.cn/img/indexboxbg.91251cd0.png") no-repeat;
    background-size: 100% 100%;
    margin-bottom: 10px;
    padding: 40px;

    .swipers {
      width: 50%;
      height: 420px;
      overflow: hidden;
      position: relative;
      cursor: pointer;

      .imgs {
        width: 100%;
        height: 420px;
        background: #fff;
        cursor: pointer;
      }
      .titles {
        width: 80%;
        position: absolute;
        bottom: 20px;
        left: 50px;
        color: #fff;
        z-index: 999;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .rightbox {
      width: 48%;
      .top {
        margin-bottom: 10px;
        width: 100%;
        display: flex;
        flex-direction: column;
        .titles {
          display: flex;
          width: 100%;
          height: 25px;
          justify-content: space-between;
          color: #c7080d;
          border-bottom: 1px solid #c80d10;
          cursor: pointer;
          .lookmore {
            cursor: pointer;
          }

          .names {
            display: flex;
            // justify-content: center;
            align-items: center;
            width: 150px;
            background: #f9e3e4;
            font-size: 20px;
            font-weight: bold;
          }
        }
        .boxlist {
          margin-top: 15px;
          margin-bottom: 15px;
          width: 100%;
          display: flex;
          flex-direction: column;
          height: 150px;
          .boxli {
            display: flex;
            align-items: center;
            height: 30px;
            line-height: 30px;
            cursor: pointer;
            .slot {
              font-size: 30px;
              color: #ffd43d;
              margin-right: 10px;
            }
            .liinfos {
              width: 85%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
  .bdboxb {
    width: 100%;
    justify-content: space-between;
    align-items: center;
    // height: 200px;
    position: relative;

    .top {
      width: 48%;
      display: flex;
      flex-direction: column;

      .titles {
        display: flex;
        width: 100%;
        height: 25px;
        justify-content: space-between;
        color: #c7080d;
        border-bottom: 1px solid #c80d10;
        cursor: pointer;

        .names {
          display: flex;
          // justify-content: center;
          align-items: center;
          width: 150px;
          background: #f9e3e4;
          font-size: 20px;
          font-weight: bold;
        }
      }
      .boxlist {
        margin-top: 20px;
        width: 100%;
        display: flex;
        flex-direction: column;
        height: 140px;
        .boxli {
          display: flex;
          align-items: center;
          height: 30px;
          line-height: 30px;
          cursor: pointer;
          .slot {
            font-size: 30px;
            color: #ffd43d;
            margin-right: 10px;
          }
          .liinfos {
            width: 85%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .title {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 99%;
    height: 30px;
    background: url("https://fxhoss.chinalaw.org.cn/img/titlebg1.ffed9573.png") no-repeat;
    background-size: 100% 100%;
    margin-top: 10px;
    position: relative;
    .lookmore {
      float: right;
      position: absolute;
      right: 2%;
      color: #c7080d;
    }
    .ttinfo {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 30px;
      width: 300px;
      color: #c50909;
      font-weight: bold;
      font-size: 24px;
      margin-left: 35px;
      span {
        width: 16px;
        height: 24px;
        background: #c50909;
      }
    }
  }
  .titlea {
    justify-content: start;
    background: none;
    margin-bottom: -16px;
    z-index: 9999;
  }
  .bdboxc {
    // margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    background: #fff8e1;
    box-shadow: none;
    border: none;
    padding: 20px 5px;
    // height: 300px;
    .titles {
      margin-top: -14px;
      display: flex;
      width: 100%;
      height: 25px;
      justify-content: end;
      color: #c7080d;
      border-bottom: 1px solid #c80d10;
      cursor: pointer;
    }

    .audio {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 140px;
      .audioli {
        cursor: pointer;
        width: 400px;
        .info {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #c7080d;
          .imgs {
            display: flex;
            align-items: center;
            width: 400px;
            height: 300px;
            margin-bottom: 10px;
          }
          .audioname {
            width: 400px;
            text-align: start;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            word-break: break-all;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
    .overlay {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      width: 100%;
      height: 30px;
      bottom: 0px;
      // color: #c7080d;
      // background: #fff8e2;
      // border: 1px solid #c7080d;
      // font-size: 16px;
    }
  }
  .bdboxd {
    width: 100%;
    // margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    background: url("https://fxhoss.chinalaw.org.cn/img/indexboxbg.91251cd0.png") no-repeat;
    background-size: 100% 100%;
    .bdinfo {
      margin-top: 30px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 140px;
      position: relative;
      background: #fff;

      .top {
        width: 48%;
        display: flex;
        flex-direction: column;
        .titles {
          display: flex;
          width: 100%;
          height: 25px;
          justify-content: space-between;
          color: #c7080d;
          border-bottom: 1px solid #c80d10;

          .names {
            display: flex;
            // justify-content: center;
            align-items: center;
            width: 150px;
            background: #f9e3e4;
            font-size: 20px;
            font-weight: bold;
          }
        }
        .titlesd {
          width: 1100px;
          z-index: 9999;
        }
        .boxlist {
          margin-top: 20px;
          width: 100%;
          display: flex;
          flex-direction: column;
          height: 180px;
          .boxli {
            display: flex;
            align-items: center;
            height: 30px;
            line-height: 30px;
            .slot {
              font-size: 30px;
              color: #ffd43d;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  .bdboxe {
    width: 100%;
    justify-content: center;
    .infobd {
      width: 100%;
      margin-top: 20px;
      .bdli {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 99%;
        height: 340px;
        background: url("https://fxhoss.chinalaw.org.cn/img/jieshaobg.7bb2d741.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        margin: 0 auto;
        margin-top: 20px;
        .ttname {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 45px;
          height: 300px;
          background: #ae0003;
          // position: absolute;
          // left: 2%;
          margin-left: 2%;
          font-size: 25px;
          color: #fff;
          writing-mode: vertical-rl;
        }
        .users_fhz {
          display: grid !important;
          grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        }
        .users {
          width: 100%;
          display: flex;
          justify-content: space-around;
          cursor: pointer;
          .uinfo {
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
              width: 150px;
              height: 200px;
            }
            .names {
              margin-top: 10px;
              color: #ae0003;
              font-size: 20px;
            }
          }
        }
        // .users_4 {
        //   width: 90%;
        //   display: flex;
        //   flex-wrap: wrap;
        //   justify-content: start !important;
        // }
      }
      .bdlien {
        margin-top: 10px;
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .liinfo {
          width: 240px;
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 22px;
          background: url("https://fxhoss.chinalaw.org.cn/img/jieshaobg.7bb2d741.png") no-repeat;
          background-size: 100% 100%;
          border: 2px solid #ae0003;
          font-weight: bold;
          color: #ae0003;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
